import { redirect, replace } from 'react-router'
import { publicAction } from '@/data/loaders';

export function loadScenario({ request, params }) {
  return new Promise(function(resolve, reject) {

    const { scenario_id, assessment_id, course_id } = params;

    if (scenario_id == "new") {
      return resolve({});
    }

    if (course_id && assessment_id) {
      publicAction("getAssessmentScenario", { id: assessment_id, course_id }, { educatorOnly: redirect("/courses") }).then(function({ data }) {
        if (data.value) {
          resolve({ data });
        } else {
          reject({text: "Assessment not found", path: "/courses/"+course_id, status: 404 });
        }
      }).catch(reject);
    } else {
      publicAction("getScenario", { id: scenario_id }, { educatorOnly: redirect("/courses") }).then(function({ data }) {
        if (data.value) {
          resolve({ data });
        } else {
          reject({text: "Scenario not found", path: "/scenarios", status: 404 });
        }
      }).catch(reject);
    }

  })
}

export function loadScenarios() {
  return publicAction("getMyScenarios", {}, { educatorOnly: redirect("/courses") });
}

export function loadTrashedScenarios() {
  return publicAction("getTrashedScenarios", {}, { educatorOnly: redirect("/courses") });
}

export function scenarioSubmit({ request, params }) {
  return new Promise(function(resolve, reject) {

    let searchParams = (new URLSearchParams((new URL(request.url)).search));
    let session_id = searchParams.get("resume_session");
    let assessment_id_param = searchParams.get("assessment_id");
    let course_id_param = searchParams.get("course_id");

    const { scenario_id, assessment_id, course_id } = params;

    request.json().then(function({ data, rubrics, sync }) {

      if (sync == "exclude" || (assessment_id && course_id)) {

        publicAction("updateAssessmentScenario", {
          id: assessment_id || assessment_id_param,
          course_id: course_id || course_id_param,
          data,
          rubrics
        }).then(function({ data }) {
          resolve(replace("/courses/"+(course_id || course_id_param)+"/assessments/"+(assessment_id || assessment_id_param)+"/edit"));
        }).catch(() => {
          resolve({success: false, date: Date.now()});
        });

      } else {

        publicAction("createOrUpdateScenario", {
          data,
          rubrics,
          id: (scenario_id == "new" || sync == "copy") ? null : scenario_id,
          sync: (sync != null && sync != "copy") ? sync : null,
          copy_id: (sync == "copy") ? scenario_id : null
        }).then(function({ data }) {
          if (assessment_id_param && course_id_param) {
            if (assessment_id_param == "new") {
              resolve(replace("/courses/"+course_id_param+"/assessments/new/"+scenario_id));
            } else {
              resolve(replace("/courses/"+course_id_param+"/assessments/"+assessment_id_param+"/edit"));
            }
          } else if (session_id) {
            resolve(redirect("/scenarios/"+scenario_id+"/preview"));
          } else {
            resolve(redirect("/scenarios"));
          }
        }).catch(() => {
          resolve({success: false, date: Date.now()});
        });

      }

    })
  })
}

export function autofillScenario({ part, scenario_data }) {
  return publicAction("autofillScenario", { part, scenario_data });
}

export function generateRandomNames() {
  return publicAction("autofillScenarioName", {})
}

export function autofillScenarioAddItem({ part, scenario_data, item_name }) {
  return publicAction("autofillScenarioAddItem", { part, scenario_data, item_name });
}

export function renameScenario({ id, title }) {
  return publicAction("renameScenario", { id, title });
}

export function trashScenario({ id }) {
  return publicAction("trashScenario", { id });
}

export function deleteScenario({ id }) {
  return publicAction("deleteScenario", { id });
}

export function restoreScenario({ id }) {
  return publicAction("restoreScenario", { id });
}

export function deleteAllTrashedScenarios() {
  return publicAction("deleteTrashedScenarios", {});
}
